import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { IonButton, IonIcon } from '@ionic/react'
import cx from 'classnames'
import { trophyOutline } from 'ionicons/icons'

import { Popover } from '@components/molecules/Popover'
import { TrophyDisabled } from '@/components/atoms/assets/TrophyDisabled'

import { IPopoverState } from '@/interfaces'

interface ILeaderboardButton {
  color: string
  isDisabled?: boolean
  contestId: UUID
  isVoteCountHidden?: boolean
  className?: string
}

export const LeaderboardButton = ({
  color,
  isDisabled = true,
  contestId,
  isVoteCountHidden,
  className,
}: ILeaderboardButton) => {
  const { t } = useTranslation('common')
  const [popover, setPopover] = useState<IPopoverState>({
    isVisible: false,
    header: null,
    message: null,
    withIcon: false,
  })

  const handleButtonClick = (e) => {
    if (isDisabled) {
      e.preventDefault()

      if (isVoteCountHidden) {
        setPopover({
          isVisible: true,
          message: t('submissionVotes.title'),
          withIcon: true,
        })
      }

      return
    }
  }

  return (
    <>
      <Popover
        hasIcon={false}
        isOpen={popover.isVisible}
        popoverIcon={<TrophyDisabled />}
        onDismiss={() => {
          setPopover({ isVisible: false, message: null })
        }}
        onDismissClassName="normal-case"
        actionText={t('okay')}
      >
        {popover.message}
      </Popover>
      <IonButton
        className={cx(className, {
          '!cursor-not-allowed plain': isDisabled,
          'opacity-50': isDisabled,
        })}
        color="plain"
        routerLink={`/contest/${contestId}/leaderboard`}
        onClick={handleButtonClick}
      >
        <IonIcon color={color} slot="icon-only" icon={trophyOutline}></IonIcon>
      </IonButton>
    </>
  )
}
